import React from 'react';
export function ProductIntro() {
  return <section className="bg-ink py-24 px-4 border-t border-white/5" data-id="element-184">
      <div className="max-w-5xl mx-auto text-center" data-id="element-185">
        <h2 className="font-display text-5xl md:text-6xl text-white mb-6 uppercase" data-id="element-186">
          Introducing <span className="text-brightGreen" data-id="element-187">Soccer Ready™</span>
          <br data-id="element-188" />
          Your Complete Youth Coaching System
        </h2>

        <p className="text-xl md:text-2xl text-amber font-medium mb-8 max-w-3xl mx-auto" data-id="element-189">
          Everything you need to plan, coach, and develop players from U4 to
          U13. Organized. Professional. Ready to use.
        </p>

        <p className="text-lg text-gray-300 mb-16 max-w-3xl mx-auto leading-relaxed" data-id="element-190">
          Soccer Ready™ eliminates the planning problem entirely. This isn't
          just a random collection of tips — it's a complete, professional
          system that thinks for you, giving you back your time while delivering
          better results on the pitch.
        </p>

        {/* Large Product Visual */}
        <div className="relative w-full max-w-4xl mx-auto aspect-video bg-forest rounded-2xl border border-white/10 shadow-2xl overflow-hidden flex items-center justify-center p-8" data-id="element-191">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-white/5 via-transparent to-transparent" data-id="element-192"></div>

          {/* Composition of covers */}
          <div className="relative w-full h-full flex items-center justify-center" data-id="element-193">
            {/* Center Main */}
            <div className="absolute z-30 transform scale-110 shadow-2xl rounded-lg overflow-hidden border border-white/20" data-id="element-194">
              <img src="https://images.unsplash.com/photo-1517466787929-bc90951d0974?auto=format&fit=crop&w=900&q=80" alt="Young soccer players running a professional training drill on the pitch" className="w-72 h-96 object-cover" data-id="element-195" />
            </div>
            {/* Left */}
            <div className="absolute z-20 -translate-x-40 -rotate-6 shadow-xl rounded-lg overflow-hidden border border-white/10 opacity-80" data-id="element-196">
              <img src="https://cdn.magicpatterns.com/uploads/dyCav4CEcPaz8dLjdAr3cG/Bono_2.webp" alt="Practice Builder" className="w-56 h-auto object-cover" data-id="element-197" />
            </div>
            {/* Right */}
            <div className="absolute z-20 translate-x-40 rotate-6 shadow-xl rounded-lg overflow-hidden border border-white/10 opacity-80" data-id="element-198">
              <img src="https://cdn.magicpatterns.com/uploads/3SA2UDv8hqCxj16oXsM3D5/Bono_4.webp" alt="Fun Games" className="w-56 h-auto object-cover" data-id="element-199" />
            </div>
            {/* Far Left */}
            <div className="absolute z-10 -translate-x-72 -rotate-12 shadow-lg rounded-lg overflow-hidden border border-white/5 opacity-60" data-id="element-200">
              <img src="https://cdn.magicpatterns.com/uploads/fP9N8UPyMpcq2RP6rgu3Xp/Bono_3.webp" alt="Parent Management" className="w-48 h-auto object-cover" data-id="element-201" />
            </div>
            {/* Far Right */}
            <div className="absolute z-10 translate-x-72 rotate-12 shadow-lg rounded-lg overflow-hidden border border-white/5 opacity-60" data-id="element-202">
              <img src="https://cdn.magicpatterns.com/uploads/tepxQHixVJC9xXrDKY8xvu/Bono_1.webp" alt="Blueprint" className="w-48 h-auto object-cover" data-id="element-203" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}